import { SectionState } from './section-state';

export const SectionStateQuerySymbol = Symbol.for('SectionStateQuery');

export interface SectionStateQuery {
  states: SectionState[];
  courseTimeSeconds: number;
}
